import { config } from '@js/state';

let answers = []; // to store answer cards
let correctAnswer = 0; // to keep track of how many answers a question has

export default class TutorialScene extends Phaser.Scene {
  constructor() {
    super({ key: 'TutorialScene' });
  }

  preload() {}

  create() {
    answers = [];
    correctAnswer = 0;
    this.cameras.main.fadeIn(500, 255, 255, 255);

    this.cardHover = this.sound.add('cardHover').setVolume(0.02);
    this.cardCorrectAudio = this.sound.add('correctCard').setVolume(0.02);

    this.ta1 = this.sound.add('ta1').setVolume(0.3);
    this.ta2 = this.sound.add('ta2').setVolume(0.3);
    this.ta3 = this.sound.add('ta3').setVolume(0.3);
    this.ta4 = this.sound.add('ta4').setVolume(0.3);

    this.masterCardFlip = this.sound.add('masterCardFlip').setVolume(0.02);
    this.cardDistribute = this.sound.add('cardDis').setVolume(0.02);
    this.cardShuffleAudio = this.sound.add('cardShuffleAudio').setVolume(0.02);
    this.levelEnd = this.sound.add('levelComplete').setVolume(0.02);

    this.add.sprite(500, 15, 'correctCounter').setOrigin(0);

    this.addSprites();
    this.cardCorrectAnim();
    this.cardDeckAnim();

    this.cardDeck.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'deckIn',
      function () {
        this.createCards();
        this.cardDistribute.play();
        this.cardMoveDown(this.card_1, 200, 114 + this.card_1.width / 2);
        this.cardMoveDown(this.card_3, 400, 388 + this.card_2.width / 2);
        this.cardMoveDown(this.card_4, 500, 525 + this.card_3.width / 2);
        this.cardMoveDown(this.card_2, 300, 251 + this.card_4.width / 2);
        this.cardMoveDown(this.card_6, 700, 799 + this.card_5.width / 2);
        this.cardMoveDown(this.card_5, 600, 662 + this.card_6.width / 2);
        this.cardMoveDown(this.card_7, 800, 936 + this.card_7.width / 2);
        this.cardMoveDown(this.card_8, 900, 1073 + this.card_8.width / 2);

        this.time.delayedCall(
          1200,
          function () {
            this.flipCard(200, this.card_1, 'card_1');
            this.flipCard(300, this.card_2, 'card_2');
            this.flipCard(400, this.card_3, 'card_3');
            this.flipCard(500, this.card_4, 'card_4');
            this.flipCard(600, this.card_5, 'card_5');
            this.flipCard(700, this.card_6, 'card_6');
            this.flipCard(800, this.card_7, 'card_7');
            this.flipCard(900, this.card_8, 'card_8');

            this.time.delayedCall(
              1800,
              () => {
                this.ta1.play();
                this.tutText.setVisible(true);
              },
              [],
              this,
            );

            this.time.delayedCall(
              6250,
              () => {
                this.masterCardFlip.play();
              },
              this,
            );

            this.flipCard(6500, this.masterCard, 'masterCard_0');

            this.time.delayedCall(
              6500,
              () => {
                this.ta2.play();
                this.tutText.setTexture('text-2').setPosition(480, 267);
              },
              [],
              this,
            );

            this.time.delayedCall(
              10000,
              () => {
                this.ta3.play();
                this.tutText.setTexture('text-3').setPosition(503, 267);
                this.handAnim(678, 460);
                this.cardEvents(this.card_5, 'card_5');
              },
              [],
              this,
            );
          },
          [],
          this,
        );
      },
      this,
    );
  }

  handAnim(x, y) {
    this.hand = this.add.sprite(x, y, 'hand').setOrigin(0);
    this.tweens.add({
      targets: this.hand,
      ease: 'Linear',
      duration: 500,
      y: 418,
      yoyo: true,
      loop: -1,
    });
  }

  cardEvents(card, cardFront) {
    card.setInteractive({ cursor: 'pointer' });
    card.on(
      'pointerover',
      () => {
        this.cardHover.play();
        card.y -= 8;
      },
      this,
    );

    card.on(
      'pointerout',
      () => {
        card.y += 8;
      },
      this,
    );

    card.on(
      'pointerdown',
      () => {
        card.setScale(0.9);
      },
      this,
    );

    card.on(
      'pointerup',
      () => {
        this.hand.setVisible(false);
        card.removeInteractive();
        card.setScale(1);
        this.flipCardCorrect(300, card, cardFront);
        correctAnswer++;
        if (correctAnswer == 2) {
          this.tutText.setVisible(false);
          this.overlay.setVisible(false);
        }
      },
      this,
    );
  }

  addSprites() {
    this.add.sprite(config.width / 2, config.height / 2, 'mainBG');
    this.overlay = this.add.sprite(config.width / 2, config.height / 2, 'overlay');
    this.tutText = this.add.sprite(272, 267, 'text-1').setOrigin(0).setVisible(false);
  }

  createCards() {
    this.card_1 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_2 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_3 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_4 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_5 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_6 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_7 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.card_8 = this.add.sprite(635, 152, 'cardBack').setOrigin(0.5);
    this.masterCard = this.add.sprite(640, 153, 'cardBack').setOrigin(0.5).setDepth(2);
  }

  cardDeckAnim() {
    this.cardDeck = this.add
      .sprite(config.width / 2, 360, 'cardsIn')
      .setOrigin(0.5)
      .setDepth(1);
    this.anims.create({
      key: 'deckIn',
      frames: this.anims.generateFrameNames('cardsIn', {
        start: 0,
        end: 29,
        zeroPad: 0,
        prefix: 'DECKIN',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.cardDeck.play('deckIn');
  }

  confettiAnim() {
    this.confetti = this.add.sprite(config.width / 2, 350, 'confettiAnim').setDepth(3);
    this.anims.create({
      key: 'confettiPlay',
      frames: this.anims.generateFrameNames('confettiAnim', {
        start: 0,
        end: 122,
        zeroPad: 0,
        prefix: 'CONFETTI0',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });
    this.confetti.play('confettiPlay');
  }

  cardCorrectAnim() {
    this.anims.create({
      key: 'flip-front',
      frames: this.anims.generateFrameNames('correctCardFlip', {
        start: 9,
        end: 84,
        zeroPad: 0,
        prefix: 'CORRECT0',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  cardMoveDown(target, delay, endX) {
    this.tweens.add({
      targets: target,
      ease: 'Sine.easeIn',
      duration: 300,
      delay: delay,
      x: endX,
      y: {
        getStart: () => 152,
        getEnd: () => 390,
      },
      yoyo: false,
      loop: 0,
    });
  }

  flipCardCorrect(delay, card, cardFront) {
    this.cardCorrectAudio.play();
    this.time.delayedCall(
      delay,
      () => {
        this.tweens.chain({
          targets: card,
          tweens: [
            {
              scale: 1.1,
              duration: 100,
            },
            {
              scaleX: 0,
              duration: 200,
              delay: 100,
              onComplete: () => {
                card.setScale(1);
                card.scaleX = 1;
                card.setTexture('correctCardFlip');

                card.play('flip-front');

                card.on(
                  Phaser.Animations.Events.ANIMATION_COMPLETE,
                  () => {
                    card.y += 8;
                    this.tweens.chain({
                      targets: card,
                      tweens: [
                        {
                          scale: 1.1,
                          duration: 100,
                          delay: 300,
                        },
                        {
                          scaleX: 0,
                          duration: 200,
                          delay: 100,
                          onComplete: () => {
                            card.setTexture(cardFront);
                          },
                        },
                        {
                          scaleX: 1.1,
                          duration: 200,
                        },
                        {
                          scale: 1,
                          duration: 100,
                        },
                      ],
                    });
                  },
                  this,
                );
              },
            },
            {
              scaleX: 1.1,
              duration: 200,
            },
            {
              scale: 1,
              duration: 100,
            },
          ],
        });

        this.time.delayedCall(
          4500,
          () => {
            this.cardCollect(card);
          },
          [],
          this,
        );
      },
      [],
      this,
    );
  }

  flipCard(delay, card, cardFront) {
    this.time.delayedCall(
      delay,
      () => {
        this.tweens.chain({
          targets: card,
          tweens: [
            {
              scale: 1.1,
              duration: 100,
            },
            {
              scaleX: 0,
              duration: 200,
              delay: 100,
              onComplete: () => {
                if (card.texture.key == 'cardBack') {
                  card.setTexture(cardFront);
                } else {
                  card.setTexture('cardBack');
                }
              },
            },
            {
              scaleX: 1.1,
              duration: 200,
            },
            {
              scale: 1,
              duration: 100,
            },
          ],
        });
      },
      [],
      this,
    );
  }

  cardCollect(card) {
    answers.push(card);

    let curve;
    let points;

    curve = new Phaser.Curves.Line(
      new Phaser.Math.Vector2(592, 619),
      new Phaser.Math.Vector2(687, 619),
    );
    points = curve.getPoints(2);

    if (correctAnswer == 1) {
      this.tweens.add({
        targets: answers[0],
        duration: 500,
        x: points[1].x,
        y: points[1].y,
        ease: 'Linear',
        onComplete: () => {
          this.ta4.play();
          this.cardEvents(this.card_8, 'card_8');
          this.tutText.setTexture('text-4').setVisible(true).setPosition(367, 267);
          this.handAnim(1073, 460);
          this.hand.setVisible(true);
        },
      });
    } else if (correctAnswer == 2) {
      this.tweens.add({
        targets: answers[0],
        duration: 500,
        angle: 5,
        x: points[2].x,
        ease: 'Linear',
      });
      this.tweens.add({
        targets: answers[1],
        duration: 500,
        x: points[0].x,
        y: points[0].y,
        angle: -5,
        ease: 'Linear',
        onComplete: () => {
          this.add.sprite(500.5, 20, 'correctCounter').setOrigin(0);
          this.levelEnd.play();
          this.confettiAnim();
          this.time.delayedCall(
            1000,
            () => {
              this.cardsShuffle();
            },
            [],
            this,
          );
        },
      });
    }
  }

  cardsShuffle() {
    this.tweens.add({
      targets: [
        this.card_1,
        this.card_2,
        this.card_3,
        this.card_4,
        this.card_5,
        this.card_6,
        this.card_7,
        this.card_8,
      ],
      ease: 'Sine.easeInOut',
      angle: 0,
      duration: 500,
      x: config.width / 2,
    });
    this.tweens.add({
      targets: [
        this.card_1,
        this.card_2,
        this.card_3,
        this.card_4,
        this.card_5,
        this.card_6,
        this.card_7,
        this.card_8,
      ],
      delay: 500,
      ease: 'Sine.easeInOut',
      duration: 1000,
      y: 153,
      onComplete: () => {
        this.masterCard.setDepth(3);
        this.flipCard(0, this.masterCard, 'masterCard_0');
        this.card_1.setVisible(false);
        this.card_2.setVisible(false);
        this.card_3.setVisible(false);
        this.card_4.setVisible(false);
        this.card_5.setVisible(false);
        this.card_6.setVisible(false);
        this.card_7.setVisible(false);
        this.card_8.setVisible(false);
      },
    });

    this.anims.create({
      key: 'shuffle',
      frames: this.anims.generateFrameNames('shuffleCards', {
        start: 0,
        end: 77,
        zeroPad: 0,
        prefix: 'DECKSHUFFLE',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.time.delayedCall(
      2500,
      () => {
        this.masterCard.setVisible(false);
        this.cardDeck.setTexture('shuffleCards');

        this.time.delayedCall(
          1000,
          () => {
            this.cardShuffleAudio.play();
          },
          this,
        );

        this.cardDeck.play('shuffle');

        this.cardDeck.on(
          Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'shuffle',
          () => {
            this.scene.stop('TutorialScene');
            this.scene.start('GameScene');
          },
          this,
        );
      },
      [],
      this,
    );
  }

  update() {}
}
